import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

export const enum NgxButtonType {
    Button = 'button',
    Submit = 'submit',
    Reset = 'reset'
}

export const enum NgxButtonColor {
    Blue = 'blue',
    Green = 'green',
    Red = 'red',
    Orange = 'orange'
}

@Component({
    selector: 'ngx-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false
})
export class NgxButton {

    // Visual.
    @Input() type: NgxButtonType = NgxButtonType.Button;
    @Input() color: NgxButtonColor | null = null;

    // Accessibility.
    @Input() tabIndex = 0;

    // States.
    @Input() disabled = false;
    @Input() loading = false;

    // Classes for the button.
    get buttonClass() {
        return {
            ['ngx-button--' + this.color]: !!this.color,
            'ngx-button--regular': !(!!this.color),
            'ngx-button--loading': this.loading
        };
    }

}
